import { render } from "./RawMaterialCard.vue?vue&type=template&id=2fddbcfe&scoped=true"
import script from "./RawMaterialCard.vue?vue&type=script&lang=js"
export * from "./RawMaterialCard.vue?vue&type=script&lang=js"

import "./RawMaterialCard.vue?vue&type=style&index=0&id=2fddbcfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fddbcfe"]])

export default __exports__